export const LINKS = {
  TERMS_OF_USE: "https://www.silo.finance/terms",
  SAFE_HARBOR_AGREEMENT:
    "https://gov.silo.finance/t/adopt-the-seal-safe-harbor-agreement/498",
  DISCORD: "https://discord.com/invite/silo-finance",
  TELEGRAM: "https://t.me/silo_finance",
  SILOPEDIA: {
    WHAT_IS_SILO: "https://silopedia.silo.finance/introduction/what-is-silo",
    DISABLED_BORROWING:
      "https://silopedia.silo.finance/borrow/borrowing#disabled-borrowing",
    MAX_LTV: "https://silopedia.silo.finance/borrow/borrowing-factors#max-ltv",
    LIQUIDATION_THRESHOLD:
      "https://silopedia.silo.finance/borrow/borrowing-factors#liquidation-threshold",
    MAX_LIQUIDATION_FEE:
      "https://silopedia.silo.finance/borrow/borrowing-factors#max-liquidation-fee",
    INTEREST:
      "https://silopedia.silo.finance/the-silo-protocol/lending-101/the-borrower#current-apr",
    FROZEN_SILO: "https://silopedia.silo.finance/faqs#q-what-is-a-frozen-silo",
    DEPRECATED_SILO: "https://silopedia.silo.finance/support/deprecated-siloes",
    FULL_REPAYMENT:
      "https://silopedia.silo.finance/borrow/repaying#full-repayment",
    ORACLE_RISK:
      "https://silopedia.silo.finance/the-silo-protocol/risks/oracle",
    PROJECTED_APY:
      "https://silopedia.silo.finance/the-silo-protocol/lending-101/the-borrower#projected-apr",
    BORROW_CURVE_LP:
      "https://silopedia.silo.finance/borrow/borrowing-against-curve-lp-tokens",
    LIQUIDATION_PRICE:
      "https://silopedia.silo.finance/borrow/liquidation-price",
    APR_STATES:
      "https://silopedia.silo.finance/the-silo-protocol/lending-101/the-borrower#apr-state",
    INCENTIVES:
      "https://silopedia.silo.finance/the-silo-protocol/protocol-design/incentives",
    AUDITED: "https://silopedia.silo.finance/security/",
    WHAT_IS_LLAMA: "https://silodao.fyi/what-is-silo-llama",
    RISKS: "https://silopedia.silo.finance/the-silo-protocol/risks",
    BORROWING_STRATEGIES:
      "https://silopedia.silo.finance/walkthroughs/borrowing-strategies",
  },
  CRV_USD: {
    PRICE_ORACLE:
      "https://etherscan.io/address/0x4dece678ceceb27446b35c672dc7d61f30bad69e",
    USDC_CURVE_POOL:
      "https://curve.fi/#/ethereum/pools/factory-crvusd-0/deposit",
    USDC_ETH_CHAINLINK:
      "https://etherscan.io/address/0x986b5E1e1755e3C2440e960477f25201B0a8bbD4",
  },
  CHAINLINK: {
    ORACLE_ADDRESSES:
      "https://docs.chain.link/docs/data-feeds/price-feeds/addresses",
  },
  DEFILLAMA: {
    SILO_POOL:
      "https://defillama.com/yields/pool/7af7a637-8541-4b77-8ee5-c3ef0fd6222b",
  },
  PT_ORACLE:
    "https://docs.pendle.finance/Developers/Oracles/IntroductionOfPtOracle",
  REDSTONE_PRICE_FEEDS:
    "https://docs.redstone.finance/docs/smart-contract-devs/price-feeds",
  ETHER_FI: "https://app.ether.fi/portfolio",
  RENZO_POINTS: "https://app.renzoprotocol.com/portfolio",
  SWELL_POINTS: "https://app.swellnetwork.io/voyage",
  MELLOW_POINTS: "https://app.mellow.finance/vaults",
  SYMBIOTIC_POINTS: "https://app.symbiotic.fi/dashboard",
  BEDROCK_POINTS: "https://app.bedrock.technology/",
  TURTLE_POINTS: "https://app.turtle.club/",
  ANZEN_POINTS: "https://rwa.anzen.finance/",
  CHAINLINK_EZETH_PRICE_FEED:
    "https://docs.chain.link/data-feeds/price-feeds/addresses?network=arbitrum&page=1&search=ezeth",
  KELP_DAO_DASHBOARD: "https://kelpdao.xyz/dashboard/",
  MERKL_REWARDS: "https://app.merkl.xyz/user/",
  WO_ETH_EXCHANGE_RATE:
    "https://arbiscan.io/address/0x03a1f4b19aaeA6e68f0f104dc4346dA3E942cC45",
  WST_ETH_EXCHANGE_RATE:
    "https://optimistic.etherscan.io/address/0xe59EBa0D492cA53C6f46015EEa00517F2707dc77",
  SILO_OBSERVER: "https://silo.observer/",
  SUPERFEST: "https://jumper.exchange/superfest/",
  CONTANGO: "https://silo.contango.xyz/",
  DLCBTC_CHAINLINK: "https://data.chain.link/feeds/arbitrum/mainnet/dlcbtc-por",
  WUSD_PLUS_CHAINLINK:
    "https://docs.chain.link/data-feeds/price-feeds/addresses?network=base&page=1&search=USD%2B",
  BASE_AERODROME_POOL:
    "https://aerodrome.finance/deposit?token0=0x4200000000000000000000000000000000000006&token1=0xF734eFdE0C424BA2B547b186586dE417b0954802&type=-1",
  SILO_STAKING: "https://staking.silo.finance/",
  REVENUE_DETAILS: "https://dune.com/silo_finance/revenue",
  V2: "https://v2.silo.finance/",
  V3: "https://app.silo.finance/",
  TOKENOMICS_UPGRADE:
    "https://gov.silo.finance/t/introducing-xsilo-a-tokenomics-upgrade-on-sonic/526",
} as const;
